

import { Component, Prop, Vue } from "vue-property-decorator";
import { DateString } from "@/DateString"

@Component
export default class CalendarVue extends Vue {
  @Prop(Date) date:Date|undefined;
  _date:Date|undefined;
   date_str:String="";
   hours=["08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00","00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00"]
   hour_str="15:00"

  key=0;

  
  mounted() {
      
      this._date=this.date;
      if (this._date==undefined) this._date=new Date()
      if (isNaN(this._date.getTime())) this._date=new Date()
      
      console.log(this._date)
      this.date_str=DateString.toISOString().substr(0,10)
      this.hour_str=this._date.getHours().toString()
      if (this.hour_str.length<2) this.hour_str="0"+this.hour_str;
      this.hour_str=this.hour_str+":00"
      this.key++
  }

  chg() {
  
      let hh=this.hour_str
      const ds=this.date_str+" "+hh+":00"
      try {
        this._date=new Date(<any>ds)
        this.date_str=DateString.toISOString().substr(0,10)
        this.$emit("date_changed",this._date)
      } catch (err) {
          alert("Niepoprawna data "+ds)
          this.date_str=""
      }
  }

  
}
